module.exports = "https://static.wmbcdn.com/uniweb/images/c0a684f19880033133f2fd90d29090e5.svg";